import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { previewDoc } from 'services/myOrders';
import withErrorBoundary from '../withErrorBoundary';

const PreviewPage = () => {
  const [urlParams] = useSearchParams();
  const str = urlParams.get('srt');
  const [base64, setBase64] = useState<string>();

  useEffect(() => {
    (async () => {
      if (!str) return;
      const data = await previewDoc(str);
      setBase64(data);
    })();
  }, [str]);
  return <div>{base64 && <img style={{ maxWidth: '100%' }} src={base64} alt="preview" />}</div>;
};

export default withErrorBoundary(PreviewPage, 'PreviewPage');
